const logMiddleware = ({ getState, dispatch }) => (next) => (action) => {
 
  console.log(action);

  next(action);
};

export default logMiddleware;



// WEBPACK FOOTER //
// ./src/State/middlewares/log.js